var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatsJoin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 66,
    viewBox: "0 0 61 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2959 32.9115C32.784 28.9534 36.4039 18.9528 32.4319 10.4346C28.4599 1.91661 18.472 -1.73876 9.9839 2.21933C1.49584 6.17738 -2.12421 16.1782 1.84781 24.6962C5.81988 33.2144 15.8078 36.8695 24.2959 32.9115ZM27.8 40.426C15.3331 46.2394 5.61003 53.1777 9.28907 61.0674C12.9665 68.9538 24.4998 66.0666 37.0315 60.223C49.4953 54.411 59.2216 47.4717 55.5425 39.582C51.8635 31.6922 40.3316 34.5824 27.8 40.426ZM52.1144 8.91659L55.8217 7.18786C57.3477 6.4763 59.1748 7.14606 59.8897 8.6791C60.6046 10.2122 59.9431 12.0423 58.4172 12.7538L54.7099 14.4826L56.3859 18.0767C57.1008 19.6098 56.4427 21.4383 54.9137 22.1513C53.3877 22.8628 51.5606 22.1932 50.8457 20.6601L49.1698 17.066L45.469 18.7917C43.9396 19.5048 42.1159 18.8336 41.401 17.3005C40.6862 15.7675 41.3442 13.9389 42.8735 13.2257L46.5743 11.5L44.8999 7.90914C44.185 6.3761 44.8464 4.5459 46.3723 3.83434C47.9014 3.12135 49.7251 3.79269 50.44 5.32573L52.1144 8.91659Z",
    fill: "url(#paint0_linear_4264_8203)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4264_8203",
    x1: -30.3858,
    y1: 21.044,
    x2: 11.8108,
    y2: 111.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsJoin);
export default __webpack_public_path__ + "static/media/stats-join.c2a4fb002a99e30030d97682ab697051.svg";
export { ForwardRef as ReactComponent };